import OrgProfile from './OrgProfile';

export default OrgProfile;
